import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { setBreadcrumb } from 'components/Navbar/modules';
import { resetAll } from 'modules/steps/actions';
import NoRecommendations from '../components';


function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.noRecommendations || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setBreadcrumb: bindActionCreators(setBreadcrumb, dispatch),
    resetAll: bindActionCreators(resetAll, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NoRecommendations));



// WEBPACK FOOTER //
// ./src/routes/NoRecommendations/container/index.js